import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    width: 64,
    height: 64,
    zIndex: 1500,
    [theme.breakpoints.down('sm')]: {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      width: 56,
      height: 56,
    },
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: theme.palette.dpoDayNavy,
    boxShadow: theme.shadows[6],
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease, transform 0.15s ease',
    '&:hover': {
      boxShadow: theme.shadows[12],
      transform: 'scale(1.05)',
    },
  },
  logo: {
    display: 'block',
    width: '76%',
    height: '76%',
    objectFit: 'contain',
  },
  closeButton: {
    position: 'absolute',
    top: -6,
    right: -6,
    width: 24,
    height: 24,
    padding: 0,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[3],
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      opacity: 0.85,
    },
  },
  closeIcon: {
    color: theme.palette.dpoDayNavy,
    fontSize: 16,
  },
}))

export default styles
